import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { GameData, makeFloat, useCurrency, FreeSpins, useWindowSize } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

interface FreeSpinsProps {
  game: GameData;
  freeSpins: FreeSpins;
}

const _GameHeaderContent = ({ game, freeSpins }: FreeSpinsProps) => {
  const { isMobileLayout } = useWindowSize();
  const { currencyIcon } = useCurrency();
  const { t } = useTranslation();

  const { numberDay, number, betAmount, dayLimit } = freeSpins || {};

  const gameFreeSpins = game?.freeSpins;

  const userFreeSpins = useMemo(() => {
    if (!gameFreeSpins || !freeSpins || number === 0) {
      return undefined;
    }
    if (number > 0 && dayLimit > 0 && numberDay === 0) {
      return undefined;
    }

    if (number > 0 && dayLimit === 0) {
      return number;
    }

    if (number > 0 && dayLimit > 0 && numberDay > 0) {
      return `${numberDay} / ${dayLimit}`;
    }

    return undefined;
  }, [freeSpins, gameFreeSpins]);

  if (!userFreeSpins) {
    return null;
  }

  return (
    <div
      className={classNames(
        'bg-fs_bg 768:pl-10 py-[5px] justify-center 768:text-base text-xs leading-[110%] flex items-center gap-5 ',
        isMobileLayout && 'landscape:justify-center'
      )}>
      <div className="flex items-center gap-1.5">
        <span className="font-bold uppercase text-fs_text">{t('freeSpins.fs')}:</span>
        <span className="font-bold text-fs_amount">{userFreeSpins}</span>
      </div>

      <div className="flex items-center gap-1.5">
        <span className="font-bold uppercase text-fs_text">{t('freeSpins.fsBet')}:</span>
        <span className="font-bold text-fs_amount ">
          {currencyIcon} {makeFloat(betAmount)}
        </span>
      </div>
    </div>
  );
};

export const GameHeaderContent = memo(_GameHeaderContent);
